import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import { fetchBacklogRetentionPolicy } from '@/slices/dictSlice';
import ColTip from '@/components/Tip';
import PermWrapper from '@/components/PermWrapper';
import { toText } from '..';
import Modal from './Modal';

function KeepPolicy({ data, fetchBacklogRetentionPolicy, commonProps }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetchBacklogRetentionPolicy();
  }, [fetchBacklogRetentionPolicy]);

  return (
    <>
      <Descriptions
        column='2'
        bordered
        title={
          <ColTip
            content={
              <>
                <strong>消息保留策略</strong>
                <li>1、一定是消息被所有订阅者都确认了，包含系统自动确认的情况。</li>
                <li>2、Topic数据是由一组Ledger组成，实际可删除的是以Ledger为粒度。</li>
                <li>3、Ledger先从元数据层删除，真正物理删除由Bookie的GC异步执行。</li>
                <li>
                  4、保留消息大小和保留消息大时长策略是或的关系，只要满足其中一个条件，则触发删除。
                </li>
                <li>5、消息过期时长和消息过期大小策略同样是或的关系。</li>
              </>
            }
          >
            消息保留策略
          </ColTip>
        }
        actions={
          <PermWrapper resource='kop:namespace:list:config'>
            <Button onClick={() => setVisible(true)} theme='default' variant='outline' size='small'>
              修改
            </Button>
          </PermWrapper>
        }
      >
        <Descriptions.Item
          label='保留消息时长'
          tip={
            <>
              <strong>保留消息时长</strong>
              <li>1、被所有订阅者都消费并确认的消息保留时长。</li>
              <li>2、如果存在消息未被确认，即使超过消息保留时长，也不会删除。</li>
              <li>3、如果该topic没有一个订阅者，认为可删除超过的消息。</li>
              <li>4、默认值为0，代表可立即标记删除，-1代表永不删除。</li>
            </>
          }
          value={toText(data.retentionTimeInSeconds, '秒')}
        />
        <Descriptions.Item
          label='保留消息大小'
          tip={
            <>
              <strong>保留消息大小</strong>
              <li>1、被所有订阅者都消费并确认的消息保留大小。</li>
              <li>2、如果存在消息未被确认，即使超过保留消息大小，也不会删除。</li>
              <li>3、如果该topic没有一个订阅者，认为可删除超过的消息。</li>
              <li>4、默认值为0，代表可立即标记删除，-1代表永不删除。</li>
            </>
          }
          value={toText(data.retentionSizeInMB, 'MB')}
        />
        <Descriptions.Item
          label='消息过期时长'
          tip={
            <>
              <strong>消息过期时长</strong>
              <li>1、每条消息在每个订阅下的生命周期。</li>
              <li>2、订阅者未消费的消息存活时长。</li>
              <li>3、到达消息过期时长后，将自动确定未消费消息。</li>
              <li>4、默认值为0，代表禁用。</li>
              <li>5、主要使用场景，避免因长时间未消费导致数据积压无法清除。</li>
              <p></p>
              <li>
                例如配置为1小时，订阅者A能够消费到的数据为最近1小时，当然这取决于自动消息确定的速率。
              </li>
            </>
          }
          value={toText(data.ttlInSeconds, '秒')}
        />
        <Descriptions.Item
          label='消息过期大小'
          tip={
            <>
              <strong>消息过期大小</strong>
              <li>1、每条消息在每个订阅下的生命周期。</li>
              <li>2、订阅者未消费的消息大小。</li>
              <li>3、到达消息过期大小后，将自动确定未消费消息。</li>
              <li>4、默认值为-1，代表禁用。</li>
              <li>5、主要使用场景，避免因未消费导致数据积压无法清除。</li>
              <p></p>
              <li>
                例如配置为1GB，订阅者A能够消费到的数据为最近1GB，当然这取决于自动消息确定的速率。
              </li>
            </>
          }
          value={toText(data.backlogQuotaSize, 'MB')}
        />
        {/* <Descriptions.Item */}
        {/*  label='Backlog Retention Policy' */}
        {/*  value={toText(data.backlogRetentionPolicy)} */}
        {/*/ > */}
      </Descriptions>
      <Modal
        visible={visible}
        commonProps={commonProps}
        detail={data}
        handleClose={() => setVisible(false)}
      />
    </>
  );
}

export default connect(
  (state) => ({
    data: state.kopNamespace.polices,
  }),
  {
    fetchBacklogRetentionPolicy,
  },
)(KeepPolicy);
